import { Drawer, styled } from '@mui/material'

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  ...theme.mixins.toolbar
}))

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  width: theme.drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: theme.drawerWidth,
    boxSizing: 'border-box'
  }
}))
